module.exports = {
  name: "专业体检中心",
  orgCode: "0060",
  serviceUrl: "https://demo.gigtech.cn/service/", 
  postUrl: "/service/datahandler.ashx",   
};